import { isStringEmpty } from "drh-js-library/dist/drh-string-utils/is-string-empty";

export function getHashQueryStringParam(
	paramName: string,
	locationHash: string,
): string {
	if (isStringEmpty(paramName) || isStringEmpty(locationHash)) {
		return "";
	}

	const params = new URLSearchParams(locationHash.substring(1));

	var paramValue = params.get(paramName)!;

	if (paramValue === null) {
		return "";
	}

	return paramValue;
}
